export default "__VITE_ASSET__B3Yi1RDw__"